module.exports = ""


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/sxAlert/alert.html
// module id = ../../../../../src/app/helpers/components/sxAlert/alert.html
// module chunks = main